module.exports = __webpack_public_path__ + "bd75b6e7e7591206a6b9d2d0bdd15f8b.svg";